<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
defineProps<{
  tabDescriptors: TabDescriptor[]
}>();

const emit = defineEmits<{
  tabSelected: [tab: TabDescriptor]
}>()

export interface TabDescriptor {
  heading: string;
  templateName: string;
}

const selectedTab = ref(0);

</script>
<template>
  <div class="tab-container">
    <div class="tab-headers">
      <div v-for="(value, index) in tabDescriptors" @click="selectedTab=index; emit('tabSelected', value)" :key=index>
        <span :class="{ 'active': selectedTab==index }">
          {{ t(value.heading) }}
        </span>
      </div>
    </div>
    <div v-for="(value, index) in tabDescriptors" :class="{ 'active': selectedTab==index }" class="tab-content" :key=index>
      <slot :name="value.templateName"></slot>
    </div>
  </div>

</template>
<style scoped>
.tab-container {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
}

.tab-headers {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  padding-bottom: 16px;
}

.tab-content {
  visibility: hidden;
  display: none;
}

.tab-content.active {
  visibility: visible;
  display: block;
}

span {
  padding: 8px;
  cursor: pointer;
  border-bottom: 2px solid var(--xyb-divider-dark-2);
  color: var(--color-text-softer);
}

span.active {
  border-bottom: 2px solid var(--color-link);
  color: var(--color-text);
}
</style>
